import React, { useState, useEffect, useRef } from 'react';
import { Typography, Paper, Box } from '@material-ui/core';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';
import useStyles from '../styles';
import { MODULES, FORMATS } from '../../../utils/const/quillModules';
import { getTask } from '../../../requests/api/task';
import { getSurveyEmail, postSurveyEmails, putSurveyEmail } from '../../../requests/api/survey-emails';
import LocationDialog from './locationDialog';
import PlaceholderDialog from './placeholderDialog';
import { getLocationsProject } from '../../../requests/api/location-projects';
import axios from '../../../utils/axios';

function EmailConfig() {
  const { t } = useTranslation();
  const { surveyId } = useParams();
  const styles = useStyles();
  const [localCompanyId, setLocalCompanyId] = useState(0);
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [mails, setMails] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [saveDatabase, setSaveDatabase] = useState(false);
  const [openLocationsDialog, setOpenLocationsDialog] = useState(false);
  const [openPlaceholderDialog, setOpenPlaceholderDialog] = useState(false);
  const [rows, setRows] = useState([]);
  const [branches, setBranches] = useState([{ id: 1, name: 'Prueba' }]);

  const updateOpenPlaceHolderDialog = () => {
    setOpenPlaceholderDialog(true);
  };
  useEffect(() => {
    if (localCompanyId) return;
    const interval = setInterval(() => {
      const currentId = axios?.defaults?.params?.companyId;
      if (currentId !== undefined) {
        setLocalCompanyId(currentId);
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, [localCompanyId]);

  const handleSave = () => {
    if (mails.length === 0) {
      /* eslint-disable no-alert */
      alert('Debe ingresar almenos un correo');
      return;
    }
    if (subject === '') {
      alert('Debe ingresar el asunto del correo');
      return;
    }
    if (body === '') {
      alert('Debe ingresar el cuerpo del correo');
      return;
    }
    if (selectedIds.length === 0) {
      alert('Debe seleccionar almenos una pregunta para enviar');
      /* eslint-enable no-alert */
      return;
    }
    const questions = JSON.stringify(selectedIds);
    if (saveDatabase) {
      putSurveyEmail(surveyId, {
        subject, body, mails, questions, rows,
      });
    } else {
      postSurveyEmails({
        subject, body, surveyId, mails, questions, rows,
      });
      setSaveDatabase(true);
    }
    window.location.href = '/tasks';
  };

  const surveyIdRef = useRef(surveyId);
  surveyIdRef.current = surveyId;

  useEffect(() => {
    const getTaskById = async () => {
      const { data, success } = await getTask(surveyIdRef.current);
      if (success) {
        setQuestions(data.data.task.Questions);
      }
    };
    getTaskById();
  }, []);

  useEffect(() => {
    const getSurveyEmailById = async () => {
      const { data, success } = await getSurveyEmail(surveyIdRef.current);
      if (success && data.data.surveyEmail) {
        const { surveyEmail } = data.data;
        const locations = surveyEmail.SurveyEmailLocations;
        setSaveDatabase(true);
        setSubject(surveyEmail.subject);
        setBody(surveyEmail.body);
        setMails(surveyEmail.mails);
        setSelectedIds(JSON.parse(surveyEmail.questions));
        locations.forEach((slocation) => {
          const emailLocation = {
            id: slocation.id,
            email: slocation.mails,
            location: slocation.locationId,
          };
          setRows((rows) => [...rows, emailLocation]);
        });
      }
    };
    getSurveyEmailById();
  }, []);

  const handleToggle = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedIds(
        questions.map((q) => q.id),
      );
    } else {
      setSelectedIds([]);
    }
  };

  useEffect(() => {
    const requestSearch = async () => {
      const response = await getLocationsProject({ page: 0, limit: 9999 });
      if (response.data.success) {
        setBranches(response.data.data.locations);
      }
    };
    if (localCompanyId !== 0) {
      requestSearch();
    }
  }, [localCompanyId]);

  const openSettingLocation = () => {
    setOpenLocationsDialog(true);
  };

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <Typography variant='h4' className={styles.title}>
          {t('task.email.title')} {surveyId}
        </Typography>
      </div>
      <Paper className={styles.taskTable} style={{ padding: '20px' }}>
        <Box mb={3}>
          <Typography variant='h6' gutterBottom> {t('task.email.emails')} </Typography>
          <input
            type="text"
            placeholder={t('task.email.emails')}
            value={mails}
            onChange={(e) => setMails(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '14px',
            }}
          />
        </Box>

        <Box mb={3}>
          <Typography variant='h6' gutterBottom>{t('task.email.subject')}</Typography>
          <input
            type="text"
            placeholder={t('task.email.subjectPlaceHolder')}
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '14px',
            }}
          />
        </Box>

        <Box mb={3}>
          <Typography variant='h6' gutterBottom>{t('task.email.body')}</Typography>
          <Button
            text={t('task.email.placeholder')}
            onClick={updateOpenPlaceHolderDialog}
            backgroundColor="#007bff"
            color="white"
          />
          <ReactQuill
            className={styles.reactQuill}
            modules={MODULES}
            formats={FORMATS}
            placeholder={t('task.email.bodyHolder')}
            theme="snow"
            value={body}
            onChange={setBody}
            style={{ height: '300px', marginBottom: '50px' }}
          />
        </Box>

        <h3>{t('task.email.selectQuestions')}</h3>
        <label key={'selectAllLabel'} style={{ display: 'block', marginBottom: 5 }}>
          <input
            type="checkbox"
            checked={selectAll}
            onChange={() => handleSelectAll()}
          />
          {t('task.email.selectAll')}
        </label>
        {questions.map((q) => (
          <label key={q.id} style={{ display: 'block', marginBottom: 5 }}>
            <input
              type="checkbox"
              checked={selectedIds.includes(q.id)}
              onChange={() => handleToggle(q.id)}
            />
            {q.title}
          </label>
        ))}
        <Box display="flex" gap={2} justifyContent="flex-end">
          <Button
            text={t('task.email.addLocation')}
            onClick={openSettingLocation}
            backgroundColor="#56bf4fff"
            color="white"
          />
          <Button
            text={t('task.email.cancel')}
            onClick={() => { window.location.href = '/tasks'; }}
            backgroundColor="#6c757d"
            color="white"
          />
          <Button
            text={t('task.email.save')}
            onClick={handleSave}
            backgroundColor="#007bff"
            color="white"
          />
        </Box>
      </Paper>
      {openLocationsDialog && (
        <LocationDialog
          openLocationsDialog={openLocationsDialog}
          setOpenLocationsDialog={setOpenLocationsDialog}
          rows={rows}
          setRows={setRows}
          branches = {branches}
        />
      )}
      {openPlaceholderDialog && (
        <PlaceholderDialog
          openPlaceholderDialog={openPlaceholderDialog}
          setOpenPlaceholderDialog={setOpenPlaceholderDialog}
        />
      )}
    </div>
  );
}

export default EmailConfig;
